'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Indeterminate = exports.Checked = exports.Unchecked = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../colors');

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Unchecked = exports.Unchecked = function (_PureComponent) {
  _inherits(Unchecked, _PureComponent);

  function Unchecked() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Unchecked);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Unchecked.__proto__ || Object.getPrototypeOf(Unchecked)).call.apply(_ref, [this].concat(args))), _this), _this.uniqueId = (0, _v2.default)(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Unchecked, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          width = _props.width,
          color = _props.color;

      return _react2.default.createElement(
        'svg',
        { name: 'unchecked', width: width, height: width, viewBox: '0 0 24 24' },
        _react2.default.createElement(
          'defs',
          null,
          _react2.default.createElement('path', {
            id: this.uniqueId,
            d: 'M0,2.38895416 C0,1.06957121 1.07785486,0 2.38895416,0 L21.6110458,0 C22.9304288,0 24,1.07785486 24,2.38895416 L24,21.6110458 C24,22.9304288 22.9221451,24 21.6110458,24 L2.38895416,24 C1.06957121,24 0,22.9221451 0,21.6110458 L0,2.38895416 Z M2.4,21.6 L21.6,21.6 L21.6,2.4 L2.4,2.4 L2.4,21.6 Z'
          })
        ),
        _react2.default.createElement(
          'g',
          { fill: 'none', fillRule: 'evenodd' },
          _react2.default.createElement('use', { fill: color, xlinkHref: '#' + this.uniqueId })
        )
      );
    }
  }]);

  return Unchecked;
}(_react.PureComponent);

Unchecked.propTypes = {
  width: _propTypes2.default.string,
  color: _propTypes2.default.string
};

Unchecked.defaultProps = {
  width: '16px',
  color: _colors.cobalt.base
};

var Checked = exports.Checked = function (_PureComponent2) {
  _inherits(Checked, _PureComponent2);

  function Checked() {
    var _ref2;

    var _temp2, _this2, _ret2;

    _classCallCheck(this, Checked);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = Checked.__proto__ || Object.getPrototypeOf(Checked)).call.apply(_ref2, [this].concat(args))), _this2), _this2.uniqueId = (0, _v2.default)(), _temp2), _possibleConstructorReturn(_this2, _ret2);
  }

  _createClass(Checked, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          width = _props2.width,
          color = _props2.color;

      return _react2.default.createElement(
        'svg',
        { name: 'checked', width: width, height: width, viewBox: '0 0 24 24' },
        _react2.default.createElement(
          'defs',
          null,
          _react2.default.createElement('path', {
            id: this.uniqueId + '-a',
            d: 'M0,1 L0,23 C0,23.5522847 0.44771525,24 1,24 L23,24 C23.5522847,24 24,23.5522847 24,23 L24,1 C24,0.44771525 23.5522847,0 23,0 L1,0 C0.44771525,0 0,0.44771525 0,1 Z'
          })
        ),
        _react2.default.createElement(
          'g',
          { fill: 'none', fillRule: 'evenodd' },
          _react2.default.createElement(
            'mask',
            { id: this.uniqueId + '-b', fill: '#fff' },
            _react2.default.createElement('use', { xlinkHref: '#' + this.uniqueId + '-a' })
          ),
          _react2.default.createElement(
            'g',
            { fill: color, mask: 'url(#' + this.uniqueId + '-b)' },
            _react2.default.createElement('rect', { width: '24', height: '24' })
          ),
          _react2.default.createElement(
            'g',
            { fill: '#FFF', mask: 'url(#' + this.uniqueId + '-b)' },
            _react2.default.createElement('path', {
              d: 'M14.7060415,0.294045226 C14.314157,-0.0980276382 13.711142,-0.0980276382 13.3190691,0.294045226 L5.11817714,8.49493719 L1.68102889,5.08797739 C1.28895603,4.69609296 0.685940955,4.69609296 0.294056533,5.08797739 C-0.0980163317,5.47986181 -0.0980163317,6.08287688 0.294056533,6.47494975 L4.42459673,10.5754899 C4.60553894,10.7562437 4.87685804,10.8769975 5.11817714,10.8769975 C5.35930779,10.8769975 5.63062688,10.7562437 5.8115691,10.5754899 L14.7060415,1.71101759 C15.0981143,1.31913317 15.0981143,0.685929648 14.7060415,0.294045226',
              transform: 'translate(4.5 6.75)'
            })
          )
        )
      );
    }
  }]);

  return Checked;
}(_react.PureComponent);

Checked.propTypes = {
  width: _propTypes2.default.string,
  color: _propTypes2.default.string
};

Checked.defaultProps = {
  width: '16px',
  color: _colors.teal.base
};

var Indeterminate = exports.Indeterminate = function (_PureComponent3) {
  _inherits(Indeterminate, _PureComponent3);

  function Indeterminate() {
    var _ref3;

    var _temp3, _this3, _ret3;

    _classCallCheck(this, Indeterminate);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this3 = _possibleConstructorReturn(this, (_ref3 = Indeterminate.__proto__ || Object.getPrototypeOf(Indeterminate)).call.apply(_ref3, [this].concat(args))), _this3), _this3.uniqueId = (0, _v2.default)(), _temp3), _possibleConstructorReturn(_this3, _ret3);
  }

  _createClass(Indeterminate, [{
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          width = _props3.width,
          color = _props3.color;

      return _react2.default.createElement(
        'svg',
        { name: 'indeterminate', width: width, height: width, viewBox: '0 0 24 24' },
        _react2.default.createElement(
          'defs',
          null,
          _react2.default.createElement('path', {
            id: this.uniqueId + '-a',
            d: 'M0,1 L0,23 C0,23.5522847 0.44771525,24 1,24 L23,24 C23.5522847,24 24,23.5522847 24,23 L24,1 C24,0.44771525 23.5522847,0 23,0 L1,0 C0.44771525,0 0,0.44771525 0,1 Z M16.8,12.9 C17.4627417,12.9 18,12.3627417 18,11.7 C18,11.0372583 17.4627417,10.5 16.8,10.5 L7.2,10.5 C6.5372583,10.5 6,11.0372583 6,11.7 C6,12.3627417 6.5372583,12.9 7.2,12.9 L16.8,12.9 Z'
          })
        ),
        _react2.default.createElement(
          'g',
          { fill: 'none', fillRule: 'evenodd' },
          _react2.default.createElement(
            'mask',
            { id: this.uniqueId + '-b', fill: '#fff' },
            _react2.default.createElement('use', { xlinkHref: '#' + this.uniqueId + '-a' })
          ),
          _react2.default.createElement(
            'g',
            { fill: color, mask: 'url(#' + this.uniqueId + '-b)' },
            _react2.default.createElement('rect', { width: '24', height: '24' })
          )
        )
      );
    }
  }]);

  return Indeterminate;
}(_react.PureComponent);

Indeterminate.propTypes = {
  width: _propTypes2.default.string,
  color: _propTypes2.default.string
};

Indeterminate.defaultProps = {
  width: '16px',
  color: _colors.teal.base
};